import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from './page.component';
import { CoursesComponent } from 'src/app/modules/courses/courses.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { CourseComponent } from 'src/app/modules/course/course.component';
import { MyAccountModule } from '../my-account/my-account.module';
import { CheckoutComponent } from 'src/app/modules/checkout/checkout.component';
import { MyCourseComponent } from 'src/app/modules/my-course/my-course.component';
import { PageNotFoundComponent } from 'src/app/modules/page-not-found/page-not-found.component';
import { EnglishCoursesComponent } from 'src/app/modules/english-courses/english-courses.component';
import { EnglishCourseComponent } from 'src/app/modules/english-course/english-course.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OtherPageComponent } from 'src/app/modules/other-page/other-page.component';
import { InstructorsComponent } from 'src/app/modules/instructors/instructors.component';
import { ContactComponent } from 'src/app/modules/contact/contact.component';
import { InstructorComponent } from 'src/app/modules/instructor/instructor.component';
import { KnowledgeComponent } from 'src/app/modules/knowledge/knowledge.component';
import { KnowledgesComponent } from 'src/app/modules/knowledges/knowledges.component';
import { PartnersComponent } from 'src/app/modules/partners/partners.component';
import { DictionaryComponent } from 'src/app/modules/dictionary/dictionary.component';

@NgModule({
  declarations: [
    PageComponent,
    CoursesComponent,
    CourseComponent,
    CheckoutComponent,
    MyCourseComponent,
    PageNotFoundComponent,
    EnglishCoursesComponent,
    EnglishCourseComponent,
    OtherPageComponent,
    InstructorsComponent,
    InstructorComponent,
    ContactComponent,
    KnowledgeComponent,
    KnowledgesComponent,
    PartnersComponent,
    DictionaryComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    MyAccountModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class PageModule {
}
